import css from "@css/modules/Listings.module.scss"
import { ListingAdUi } from "@t/Listing"
import Link from "next/link"

export function ListingHeaderAd({ listingAd }: { listingAd: ListingAdUi }) {
    if (!listingAd?.link) return null
    return (
        <Link className={css.listingHeaderAd} href={listingAd.link} aria-label={listingAd?.desktopImage?.alternativeText || "Buy book"}>
            <img
                className={css.adMobile}
                src={listingAd?.mobileImage?.url}
                width={listingAd?.mobileImage?.width}
                height={listingAd?.mobileImage?.height}
                alt={listingAd?.mobileImage?.alternativeText}
            />
        </Link>
    )
}
